export const HOST = process.env.REACT_APP_API_URL || 'http://localhost:3030'
